/* TBET PDP — Rating bar + counter animation
 * Triggers when [data-tbet-rating] enters viewport (IntersectionObserver).
 * Counter animates 0.0 → final value.
 * Bar fill animates 0% → final % via CSS keyframe.
 * Synced: 0.8s, ease-out (cubic-bezier(0,0,0.2,1)).
 * Honours prefers-reduced-motion.
 */
(function () {
  'use strict';

  var DURATION = 800;
  var EASE = function (t) {
    // cubic-bezier(0, 0, 0.2, 1) approximation
    return 1 - Math.pow(1 - t, 3);
  };

  function animateCounter(el, target) {
    var start = performance.now();
    function step(now) {
      var elapsed = now - start;
      var t = Math.min(elapsed / DURATION, 1);
      var eased = EASE(t);
      var value = (target * eased).toFixed(1);
      el.textContent = value;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(1);
    }
    requestAnimationFrame(step);
  }

  function init() {
    var rating = document.querySelector('[data-tbet-rating]');
    if (!rating) return;

    var numEl = rating.querySelector('[data-tbet-rating-num]');
    var target = parseFloat(rating.getAttribute('data-rating-value')) || 0;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      // skip animation, leave at end-state
      if (numEl) numEl.textContent = target.toFixed(1);
      rating.setAttribute('data-tbet-rating-animate', '');
      return;
    }

    // Set counter to 0.0 initially
    if (numEl) numEl.textContent = '0.0';

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Trigger CSS bar animation
          rating.setAttribute('data-tbet-rating-animate', '');
          // Trigger counter animation
          if (numEl) animateCounter(numEl, target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(rating);

    // Skip-to-end on tab focus during animation
    rating.addEventListener('focus', function () {
      if (numEl) numEl.textContent = target.toFixed(1);
      rating.setAttribute('data-tbet-rating-animate', '');
    }, { once: true, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
